/**
 * The app route for a `ScanTarget` — the API decides *where* a scanned label
 * goes; this maps that decision onto this app's URLs, which the API
 * deliberately does not know.
 *
 * `job` opens the mobile job view, which scrolls to the next open checklist
 * task itself (docs/qr-scan-workflow-requirements.md §9).
 */

import type { ScanTarget } from '@techgitter/contracts';

export function scanTargetRoute(target: ScanTarget): string {
  const n = encodeURIComponent(String(target.ticketNumber));
  switch (target.destination) {
    case 'check_in_device':
      if (target.sessionId && target.draftJobId) {
        return `/check-in/session/${target.sessionId}/job/${target.draftJobId}`;
      }
      return target.sessionId ? `/check-in/session/${target.sessionId}` : `/ticket/${n}`;
    case 'check_in_session':
      return target.sessionId ? `/check-in/session/${target.sessionId}` : `/ticket/${n}`;
    case 'pickup':
      return `/pickup/${n}`;
    case 'start_dropoff':
      return `/check-in/new?dropoff=${n}`;
    case 'job_summary':
      return `/job/${n}/summary`;
    case 'job':
      return `/job/${n}`;
    default:
      return `/ticket/${n}`;
  }
}
